import { useEffect, useRef, useState } from 'react';
import { css } from '@emotion/css';
import { Analyser } from '../utils/analyser';
import { useAudioPlayer } from '../../../components/common/audio/useAudioPlayer';

const src = 'https://storage.googleapis.com/multiplayer-images-public/podcasts/welcome-pod.wav';

export function StaticAudioVisualizer() {
  const [scale, setScale] = useState(1);
  const { play, pause, isPlaying, audioEl, addTrack } = useAudioPlayer();
  const animationFrameId = useRef<number | null>(null);
  const analyserRef = useRef<Analyser | null>(null);
  const audioContextRef = useRef<AudioContext | null>(null);

  useEffect(() => {
    if (audioEl) {
      if (!analyserRef.current) {
        audioEl.crossOrigin = 'anonymous';
        const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
        const sourceNode = audioContext.createMediaElementSource(audioEl);
        sourceNode.connect(audioContext.destination);
        analyserRef.current = new Analyser(sourceNode);
        audioContextRef.current = audioContext;
      }
    }
  }, [audioEl]);

  useEffect(() => {
    const animate = () => {
      if (analyserRef.current) {
        analyserRef.current.update();
        const newScale = 1 + (0.4 * analyserRef.current.data[1]) / 255;
        setScale(newScale);
        animationFrameId.current = requestAnimationFrame(animate);
      }
    };

    if (isPlaying) {
      animationFrameId.current = requestAnimationFrame(animate);
    } else {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
      setScale(1);
    }

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [isPlaying]);

  const handlePlayPause = () => {
    if (isPlaying) {
      pause();
    } else {
      play();
    }
  };

  useEffect(() => {
    addTrack(src);
  }, [addTrack]);

  return (
    <div>
      <button onClick={handlePlayPause}>{isPlaying ? 'Pause' : 'Play'}</button>
      <div
        className={css`
          width: 291px;
          height: 291px;
          background-color: #d9d9d9;
          border-radius: 50%;
          transform: scale(${scale});
          margin: 20px auto;
          transition: all 0.1s ease-out;
        `}
      />
    </div>
  );
} 